import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png"; 
import range from "../../Assets/Projects/Range_Breakout.png";
import tmea from "../../Assets/Projects/GIF.gif";
import tmea1 from "../../Assets/Projects/TMEA2.jpg";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={range}
              isBlog={false}
              title=" RBO Strategy"
              description="I’ve designed the powerful Forex/Crypto Range Breakout strategy that works seamlessly on any MetaTrader platform. It’s crafted for traders looking to capitalize on market momentum with precision. Get a free demo !"
              ghLink="https://github.com/Chermitifx/Range_Breakout"
              demoLink="https://www.mql5.com/en/market/product/118229?source=Site+Profile+Seller"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tmea}
              isBlog={false}
              title="Trade Manager Expert"
              description="This is my custom-designed trade management tool for MT4/MT5. It will allow you to:

Customize trade risk per lot size, set SL levels, and determine risk-reward-ratios.
Quickly CLOSE & MANAGE your trades with dedicated buttons.
View key information like TP,SL, and open price(OP) displayed directly on the chart for added convenience."
              ghLink="https://github.com/Chermitifx/Range_Breakout"
              demoLink="https://www.freelancer.com/u/BechirChermiti"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tmea1}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              ghLink="https://github.com/Chermitifx/Range_Breakout"
             // demoLink="https://www.freelancer.com/u/BechirChermiti"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Plant AI"
              description="Used the plant disease dataset from Kaggle and trained a image classifer model using 'PyTorch' framework using CNN and Transfer Learning with 38 classes of various plant leaves. The model was successfully able to detect diseased and healthy leaves of 14 unique plants. I was able to achieve an accuracy of 98% by using Resnet34 pretrained model."
              ghLink="https://github.com/soumyajit4419/Plant_AI"
             // demoLink="https://www.freelancer.com/u/BechirChermiti"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
